import NotificationsList from "shared/components/dashboardCommon/notificationsList";

const CollaboratorNotifications = () => {
  return <NotificationsList pageHeadingSize="large" />;
};

export default CollaboratorNotifications;
